import React from 'react';

import './card.style.scss';

import {typepage_rech} from '../../App.js';

export const Card = (props) => (
    <div className="card-container">
        <a href={props.grp.link}>
        <div className="notes"><img className="etoile-verte" src="https://choisirmongroupement.com/adm/img/une-etoile-verte.svg" alt="étoile"></img>
            <span className="note-et-avis">
               <span className="note"></span>
               <span className="avis"></span>
            </span>
        </div>
        
        <img alt={typepage_rech} src={props.grp.logo} />
        <div className="title">{props.grp.name}</div>
        <div className="adresse">{props.grp.gr_adr1}</div>
        <div className="adresseb">{props.grp.gr_adr2}</div>
        <div className="adresse2">{props.grp.gr_code} {props.grp.gr_ville}</div>
        </a>
    </div>
);